// import TableHeader from '@crema/core/AppTable/TableHeader'
import { Table, TableContainer, CircularProgress } from "@mui/material";
import {
  createColumnHelper,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import LoadingWrapper from "common/components/common/LoadingWrapper";
import _ from "lodash";

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CorePagination from "./components/CorePagination";
import CoreTableBody from "./components/CoreTableBody";
import CoreTableHead from "./components/CoreTableHead";
// import PropTypes from 'prop-types'

const INIT_CONTEXT = {};
const CoreTableContext = React.createContext(INIT_CONTEXT);

export const useCoreTableContext = () => useContext(CoreTableContext);

export const columnHelper = createColumnHelper();
const CoreTable = ({
  data, //empty se rerender body
  columns = [],
  totalItem = 0,
  isShowPagination = false,
  isPaginationLocal = false,
  pageSize = 20,
  pageIndex = 0,
  handleFetchData = (page) => {},
  loading = false,
  notPaddingTableCell = false,
  isHighlightRow = true,
  customStyle=false,
  warningTable = {
    isShow: false,
    content: "",
  },
  ...restProps
}) => {
  const { t } = useTranslation("uaa");
  //   const rerender = React.useReducer(() => ({}), {})[1];
  // const defaultData = React.useMemo(() => [], []);

  const pagination = React.useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: isPaginationLocal
      ? getPaginationRowModel()
      : undefined,
    initialState: {
      pagination,
    },
    debugTable: true,
  });
  const allColumns = table.getAllColumns();
  return (
    <CoreTableContext.Provider
      value={{
        table,
        t,
        pagination,
        isPaginationLocal,
        loading,
        isHighlightRow,
      }}
    >
      <TableContainer
        className="relative"
        style={{  border: "1px solid #DFE0EB", minHeight: 96, maxHeight: customStyle ? 380 : null, overflowY: customStyle ? 'auto':null }}
        sx={{
          "& tr > th, & tr > td": {
            whiteSpace: "nowrap",
          },
          "& tr > td": {
            py: notPaddingTableCell ? 0 : 2,
          },
        }}
      >
        {loading ? (
          <div className="relative h-60">
            <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center z-99 table-loading">
              <CircularProgress />
            </div>
            <div className="absolute top-0 bottom-0 left-0 right-0 bg-primary-50 opacity-30" />
          </div>
        ) : (
          <Table stickyHeader className="table">
            <CoreTableHead />
            {_.isNil(data) || !data.length ? (
              <tr>
                <td align="center" colSpan={allColumns?.length}>
                  {t("table.no_data")}
                </td>
              </tr>
            ) : (
              <CoreTableBody />
            )}
          </Table>
        )}
  
        {warningTable.isShow ? (
          <div className="tableWarning">{warningTable.content}</div>
        ) : null}
      </TableContainer>
      {isShowPagination && !!totalItem && (
        <CorePagination
          customStyle={customStyle}
          isPaginationLocal={isPaginationLocal}
          totalItem={totalItem}
          onChangePagination={(val) => {
            handleFetchData({
              pageSize: val.size,
              pageIndex: val.page,
            });
          }}
        />
      )}
    </CoreTableContext.Provider>
  );
  
  
};

export default React.memo(CoreTable);
